// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Models
import { Report, ReportHelper } from '../../models/b2b/reports';
import { User, UserHelper } from '../../models/b2b/user';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { of } from 'rxjs';
import { delay, map } from 'rxjs/operators';

@Injectable()
export class ZohoService {
    reportsCallInProgess = false;
    constructor(private api: ApiService) {}

    getReports(id: string): Observable<Report[]> {
        if (this.reportsCallInProgess) {
            return of([]);
        }
        this.reportsCallInProgess = true;
        // let url = 'https://soledadopinions.servidorbeta.com/api/';
        const url = 'https://soledadopinions.servidorbeta.com/zoho/';
        let param: HttpParams = new HttpParams();

        const token = localStorage.getItem('tokenOpinions');

        param = param.set('codigo_cliente', id);

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'text/plain',
                'X-Authorization-Token': token,
            }),
        };

        return this.api.post(url, param.toString(), options).pipe(
            map(
                (data) => {
                    this.reportsCallInProgess = false;
                    if (data.success === false) {
                        throw new Error(data.message || 'Error obtaining reports');
                    }

                    const reports: Report[] = data.results.map((x) => ReportHelper.transformFromApi(x));

                    return reports;
                },
                (error) => {
                    this.reportsCallInProgess = false;
                    throw new Error(error);
                }
            )
        );
    }

    getPromoReports(id: string): Observable<Report[]> {
        return this.getReports(id).pipe(
            map((data) => {
                const promoReports = data.filter((report) => report.promocion != '');
                // console.log({promoReports});

                return promoReports;
            })
        );
    }

    createReport(data: any, user: User) {
        const defaultAddress = UserHelper.getUserDefaultAddress(user);
        const url = 'https://soledadopinions.servidorbeta.com/zoho/add_ticket';
        const token = localStorage.getItem('tokenOpinions');

        let param: HttpParams = new HttpParams();

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'text/plain',
                'X-Authorization-Token': token,
            }),
        };

        param = param.set('source', 'incidencia');
        param = param.set('incidencia', data.concepto ?? '');
        param = param.set('num_pedido', data.pedido ?? '');
        param = param.set('num_albaran', data.albaran ?? '');
        param = param.set('num_factura', data.factura ?? '');
        param = param.set('num_promocion', data.promocion ?? '');
        param = param.set('tipo', data.typeIncident ?? '');
        param = param.set('contact_name', user.clienteNombre ?? '');
        param = param.set('cod_cliente', user.clienteCodigo ?? '');
        param = param.set('direccion', user.clienteDireccion ?? '');
        param = param.set('email', data.email ?? '');
        param = param.set('AL_CODIGO', user.almacenCodigo ?? '');
        param = param.set('dir_envio', '' + defaultAddress.codigo);

        data.almacen !== '' ? param.set('AL_PEDIDO', data.almacen) : 0;

        // TEST
        // return of(1);
        return this.api.post(url, param.toString(), options);
    }
}
